import { EmptyTableProps } from '../components/AppTableV2';

// Todo update the implementation to i18
export const businessNameSearchErrorMessage =
  'Oops! Something went wrong. We are unable to contact server. Please retry.';

export const noOnboardedTeammatesErrorMessage: EmptyTableProps = {
  description:
    'There are currently no onboarded team members in this workspace.',
  icon: 'usersThree',
  title: 'No onboarded teammates found',
};
